<div class="content-header">
    <div class="logo-and-title">
        <img src="/assets/images/v2/icons/latest-bets.svg" class="logo">
        <div>
            <div class="username">All bets</div>
            <h5>Latest bets</h5>
        </div>
    </div>
</div>
<div class="content-body" *ngIf="logs">
    <div class="latest-bets-item" *ngFor="let log of logs" @items (click)="show(log)">
        <div class="latest-bets-game">
            <img [src]="service.getGameDetails(log.game).icon">
            <div class="game-name">
                {{ service.getGameDetails(log.game).title }}
                <div class="game-date">{{ log.finishedAt | date : 'hh:mm a' }}</div>
            </div>
        </div>
        <div class="latest-bets-user">{{ log.username }}</div>
        <div class="latest-bets-bet">{{ log.bet | crypto: log.currency : 'code' : false  }}</div>
        <div class="latest-bets-profit">
            <span [class.win]="log.profit > 0" [class.lost]="log.profit < 0">{{ log.profit | crypto: log.currency : 'code' : false : true }}</span>
            <img src="/assets/images/currency/3d/{{log.currency}}.svg">
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/leaderboard-bets-wrapper/latest-bets/latest-bets.template.html